import { Dropdown } from 'react-bootstrap';
import Icon from './ComplaintIcon';

// Bootstrap supplies keyboard navigation, Escape and outside-click dismissal.
const ComplaintLocationSelect = ({ label, value, options, placeholder, disabled, onChange }) => {
    const selected = options.find((option) => option._id === value);
    return (
        <Dropdown className="complaint-location-select">
            <Dropdown.Toggle
                variant=""
                className="complaint-location-toggle"
                disabled={disabled}
                aria-label={`${label}: ${selected?.name || placeholder}`}
            >
                <span>{selected?.name || placeholder}</span>
                <Icon icon="mdi:chevron-down" aria-hidden="true" />
            </Dropdown.Toggle>
            <Dropdown.Menu className="complaint-location-menu" renderOnMount={false}>
                <Dropdown.Item as="button" type="button" active={!value} onClick={() => onChange('')}>
                    <span>{placeholder}</span>
                    {!value && <Icon icon="mdi:check" aria-hidden="true" />}
                </Dropdown.Item>
                {options.map((option) => (
                    <Dropdown.Item as="button" type="button" key={option._id} active={value === option._id} onClick={() => onChange(option._id)}>
                        <span>{option.name}</span>
                        {value === option._id && <Icon icon="mdi:check" aria-hidden="true" />}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default ComplaintLocationSelect;
